/**
 * An Enum providing default values for timeouts to pass on to the debounce function for various use-cases.
 */
var DebounceDelays;
(function (DebounceDelays) {
  DebounceDelays[DebounceDelays["Resize"] = 200] = "Resize";
  DebounceDelays[DebounceDelays["Scroll"] = 50] = "Scroll";
})(DebounceDelays || (DebounceDelays = {}));

export { DebounceDelays as D };
